import { BodyText, Spinner } from '@servicetitan/design-system';
import { FC } from 'react';
import { Centered } from './centered';

export const Loader: FC<{ text: string }> = ({ text }) => (
    <Centered>
        <Spinner />
        <BodyText subdued className="m-t-1">
            {text}
        </BodyText>
    </Centered>
);

export const PageLoader: FC<{ text?: string }> = ({ text }) => (
    <Centered fullPage>
        <Spinner />
        <BodyText subdued className="m-t-1">
            {text ?? 'Loading'}
        </BodyText>
    </Centered>
);
